<template>
  <d-container fluid class="px-3 main-content-container">
    <d-form-row>
      <!-- CEP -->
      <d-col md="2" class="form-group">
        <label for="inputCEP">CEP</label>
        <masked-input
          type="text"
          class="text-left form-control"
          id="inputCEP"
          placeholder="00.000-000"
          :mask="[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
          :guide="false"
          v-model="address.zipcode"
          @blur="searchCEP(address.zipcode)"
          :readonly="isRepresentative"
        ></masked-input>
      </d-col>
      <!-- Logradouro -->
      <d-col md="8" class="form-group">
        <label for="feInputEndereco">Logradouro</label>
        <d-form-input
          type="text"
          id="feInputEndereco"
          placeholder="Rua,Av,Travessa"
          v-model="address.address"
          @change="capitalizeAddressInput('address')"
          :readonly="isRepresentative"
        />
      </d-col>

      <!-- Numero -->
      <d-col md="2" class="form-group">
        <label for="feInputNumero">Número</label>
        <d-form-input
          type="text"
          id="feInputNumero"
          placeholder="Número"
          v-model="address.number"
          :readonly="isRepresentative"
        />
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Complemento -->
      <d-col md="3" class="form-group">
        <label for="feInputComplemento">Complemento</label>
        <d-form-input
          type="text"
          id="feInputComplemento"
          v-model="address.address2"
          placeholder="apartamento,bloco,etc..."
          @change="capitalizeAddressInput('address2')"
          :readonly="isRepresentative"
        />
      </d-col>

      <!-- Bairro -->
      <d-col md="3" class="form-group">
        <label for="feInputBairro">Bairro</label>
        <d-form-input
          type="text"
          id="feInputBairro"
          v-model="address.district"
          @change="capitalizeAddressInput('district')"
          :readonly="isRepresentative"
        />
      </d-col>

      <!-- Cidade -->
      <d-col md="4" class="form-group">
        <label for="feInputCidade">Cidade</label>
        <d-form-input
          type="text"
          id="feInputCidade"
          v-model="address.city"
          @change="capitalizeAddressInput('city')"
          :readonly="isRepresentative"
        />
      </d-col>

      <!-- Estado -->
      <d-col md="2" class="form-group">
        <label for="feInputEstado">Estado</label>
        <select-state :model.sync="address.state" :readonly="isRepresentative" />
      </d-col>
    </d-form-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import MaskedInput from 'vue-text-mask';
import Events from '_utils/events';
import SelectState from '_shared/SelectState.vue';
import { capitalize, getCep } from '_utils';
import { ADDRESS } from './DistributorModel';

export default {
  name: 'addresses',
  components: {
    SelectState,
    MaskedInput,
  },
  props: {
    model: {
      type: Object,
      default: () => ({ ...ADDRESS }),
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isRepresentative() {
      const { user } = this.$store.state.user;
      if (user && user.settings.type.slug === 'representative') {
        return true;
      }
      return false;
    },
    address: {
      get() {
        return this.model;
      },
      set(val) {
        Events.$emit('update:model', val);
      },
    },
  },
  methods: {
    ...mapActions(['activeAlert', 'getResellerAddress']),
    capitalizeAddressInput(field) {
      this.address[field] = capitalize(this.address[field]);
    },
    searchCEP(cep) {
      getCep(cep).then(response => {
        this.address.city = response.city;
        this.address.state = response.state;
        this.address.address = response.street;
        this.address.district = response.neighborhood;
        this.$emit('changeCep', this.address);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
</style>
